import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { Breadcrumb, Col, Row, Tabs } from 'antd';

import FurnishingDetailsTab from './FurnishingDetailsTab/FurnishingDetailsTab';


const TabPane = Tabs.TabPane;

const FrontDeskFurnishing = () => {
    
    const {furnishingId} = useParams();


    return (
        <Row style={{display: 'flex', flexFlow: 'column', height: '100%'}}>
            <Row style={{width: '100%', height: 40, marginBottom: 10}}>
                <Col span={22}>
                    <Row style={{marginLeft: 40, width: '100%', height: 40}}>
                        <Col span={12} style={{display: 'flex', alignItems: 'center'}}>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <NavLink to={'/app/maintenance/rooms'}>{'Habitaciones'}</NavLink>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <NavLink to={'/app/maintenance/frontdesk'}>{'Detalle de hotel'}</NavLink>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {'Detalle de mobiliario'}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Tabs defaultActiveKey={1}>
                <TabPane tab="Información general" key="1">
                    <FurnishingDetailsTab furnishingId={furnishingId}/>
                </TabPane>
            </Tabs>
        </Row>
    );
}

export default FrontDeskFurnishing;